import { type ReactNode } from 'react'
import { RunStateContext } from './runStateContext.internal'
import { RunStateStore } from '../../stores/RunStateStore'

export function RunStateProvider({
    store,
    children,
}: {
    store: RunStateStore
    children: ReactNode
}) {
    return (
        <RunStateContext.Provider value={store}>
            {children}
        </RunStateContext.Provider>
    )
}
